import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {LoginSSOGoogleComponent} from './login/login-sso/login-sso-google/login-sso-google.component';
import {LoginSSOMicrosoftComponent} from './login/login-sso/login-sso-microsoft/login-sso-microsoft.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ForgotPasswordComponent} from '@app/auth/auth-components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AuthenticatedGuard} from '@app/shared/auth/authenticated.guard';
import {UnauthenticatedGuard} from '@app/shared/auth/unauthenticated.guard';
import {PasswordResetAllowGuard} from '@app/shared/auth/password-reset-allow.guard';
import {SharedModule} from '@app/shared/shared.module';
import {RouterModule} from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';


@NgModule({
  declarations: [
    // AuthLayoutComponent,
    LoginComponent,
    LoginSSOGoogleComponent,
    LoginSSOMicrosoftComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RegisterComponent,
    ConfirmEmailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    RouterModule
  ],
  providers: [
    AuthenticatedGuard,
    UnauthenticatedGuard,
    PasswordResetAllowGuard
  ]
})
export class AuthComponentsModule {
}
